
import {
  apiShopLists,
  apiShopSwitchStatus,
  apiShopDelete,
  apiChangeRemark,
  apiShopCp,
  apiAddBanner
} from "@/api/shop";
import { Component, Prop, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import ExportData from "@/components/export-data/index.vue";
import LsDialog from "@/components/ls-dialog.vue";
import { RequestPaging } from "@/utils/util";
import DatePicker from "@/components/date-picker.vue";
import { apiOtherLists } from "@/api/order";
import MaterialSelect from "@/components/material-select/index.vue";
import { apiNewsShopLists } from "@/api/shop";
@Component({
  components: {
    lsPagination,
    ExportData,
    LsDialog,
    DatePicker,
    MaterialSelect,
  },
})
export default class ShopList extends Vue {
  /** S Data **/

  apiShopLists = apiShopLists;

  pager: RequestPaging = new RequestPaging();

  searchObj = {
    set_meal_id: "",
    set_meal_status: "",
    status: "",
    shop_info: "",
    start_time: "",
    end_time: "",
    time_type: "",
  };
  otherLists: any = {
    set_meal: [],
    pay_status: [],
    pay_way: [],
  };

  // 添加轮播图相关
  showBannerDialog = false;
  bannerLoading = false;
  shopList: any[] = [];
  bannerForm = {
    image: "",
    shop_ids: [] as number[],
  };
  bannerRules = {
    image: [{ required: true, message: "请上传轮播图片", trigger: "change" }],
  };
  /** E Data **/

  /** S Methods **/
  // 获取订单其他 方式数据
  getOtherMethodList() {
    apiOtherLists().then((res: any) => {
      this.otherLists = res;
    });
  }
  // 获取商城列表
  getShopLists(): void {
    this.pager.request({
      callback: apiShopLists,
      params: {
        ...this.searchObj,
      },
    });
  }

  // 修改商城状态
  async shopSwitchStatusEdit(status: number, id: number): Promise<void> {
    await apiShopSwitchStatus({ id });
    this.getShopLists();
  }

  async changeRemarks(text: string, id: number): Promise<void> {
    await apiChangeRemark({ id: id, remark: text });
    this.getShopLists();
  }

  // 删除商城
  async onShopDelete(row: any): Promise<void> {
    await apiShopDelete({ id: row.id });
    this.getShopLists();
  }

  // 重置搜索
  reset(): void {
    Object.keys(this.searchObj).map((key) => {
      this.$set(this.searchObj, key, "");
    });
    this.getShopLists();
  }

  //复制商家信息
  async toShopCp(id: number | any):Promise<void> {
    await apiShopCp({ id: id });
    this.getShopLists();
  }


  // 去编辑商城
  toShopEdit(id: number | any): void {
    this.$router.push({
      path: "/shop/lists_detail",
      query: {
        id: id,
      },
    });
  }

  // 修改超级管理员
  toSuperAdminUpdate(id: number | any): void {
    this.$router.push({
      path: "/shop/modify_account",
      query: {
        id: id,
      },
    });
  }

  // 去商家后台
  toShop(url: any, status: number) {
    if (status == 0) return this.$message.error("该商城暂未营业中");

    if (url.indexOf("https://") === 0) window.open(url);
    else if (url.indexOf("http://") === 0) window.open(url);
    else window.open("http://" + url);
  }

  /** E Methods **/

  /** S Banner Methods **/
  // 获取商城列表（用于下拉选择）
  async getShopListForBanner(): Promise<void> {
    const res: any = await apiNewsShopLists({});
    if (res && res.data) {
      this.shopList = res.data;
    }
  }

  // 提交轮播图
  async submitBanner(): Promise<void> {
    const refs = this.$refs["bannerForm"] as HTMLFormElement;
    refs.validate(async (valid: boolean) => {
      if (!valid) return;

      this.bannerLoading = true;
      try {
        await apiAddBanner({
          image: this.bannerForm.image,
          shop_ids: this.bannerForm.shop_ids,
        });
        this.$message.success("轮播图添加成功");
        this.showBannerDialog = false;
        this.bannerForm.image = "";
        this.bannerForm.shop_ids = [];
      } catch (e: any) {
        this.$message.error(e.msg || "添加失败");
      } finally {
        this.bannerLoading = false;
      }
    });
  }
  /** E Banner Methods **/

  /** S ods **/
  created() {
    this.getShopLists();
    this.getOtherMethodList();
    this.getShopListForBanner();
  }
}
